export default "/_next/static/images/ec/talk-ec5ab063c11817ca50524e0c2e4974ea.jpg";